export default {
    1: "Clean",//保洁服务
    2: "",//保安服务
    3: "",//陪护服务
    4: "",//运送服务
    5: "",//投诉监督
    6: "",//用车服务
    7: "",//报修服务
    8: "EquipmentMaintenance",//运送服务设备维保服务
    9: "EquipmentInspection",//设备巡检
    10: ""//区域巡检
}
